(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  var sel = '.dz-sec .dz-head, .dz-sec .dz-card, .dz-sec .dz-img, .dz-cmp, .dz-demo__stage, .dz-specs';
  var els = Array.prototype.filter.call(document.querySelectorAll(sel), function(el){ return !el.closest('.dz-hero') && !el.closest('.dz-rev__track'); });
  if (!els.length) return;
  document.documentElement.classList.add('dz-anim');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  els.forEach(function(el, i){ el.classList.add('dz-rv'); el.style.setProperty('--d', (i % 4) * 80 + 'ms'); io.observe(el); });
})();
